import OperationRepository from '@/libs/customAxios/operationAxios'

const cacheResource = '/merchant/cache'

export default {
  getCacheRefreshKeys() {
    return OperationRepository.get(`${cacheResource}/refresh-keys`)
  },
}
